import ApiServer from "../../ApiServer.js";
import * as Redim from "../../lib/redim/imageRedim.js";
import * as Html from "../../util/Html.ts";
import * as Medias from "../../server/Medias.js";

export {init}
Html.registerWidget('widget/form/input-coverauto',{init:init})

/**
 * must be set on a tag LABEL
 * input for cover, if a name is not set the cover is automaticaly updated
 * if set, it will be uploaded when the form is submitted (so set good name)
 */
function init(node){

  var 
    currentValue,
    inputFile,
    name = node.attr('data-name');

  if(name){
    node.append('<input name="'+name+'" type="file" style="display:none" accept="image/*">');
  }else{
    node.append('<input type="file" style="display:none" accept="image/*">');
  }
  inputFile = node.find('input');
  
  function onchange(blob){
    currentValue = URL.createObjectURL(blob);
    node.css("background-image","url('"+currentValue+"')");
    if(!name){
      ApiServer.accupdatefamily(null,null,blob,function(){
        currentValue = null;
      })  
    }
  }
  inputFile.on('change',async function(){
    if(!this.files[0]){
      return;
    }
    if(!await Medias.checkQuota()) return;
    
    Redim.downsize(this.files[0],{width:1024,height:1024},onchange,onchange);
    
  });
  if(currentValue){
    node.css("background-image","url('"+currentValue+"')");
  }
  node.on("click",function(e){
    if(node.parents(".fw-menu-open").length){
      e.preventDefault();
      node.parents(".fw-menu-open").click()
    }
    
  });
}